import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { LineChart } from '@/components/charts/line-chart';
import { useOccupancyChart } from '@/routes/(app)/(scenarios)/hooks/use-occupancy-chart';
import { Simulation } from '@/routes/(app)/(scenarios)/types';

interface SimulationOccupancyChartProps {
  simulation: Simulation;
}

export const SimulationOccupancyChart: FC<SimulationOccupancyChartProps> = ({
  simulation,
}) => {
  const { t } = useTranslation();
  const { data, lines, regions } = useOccupancyChart([simulation], {
    showValueLabels: true,
  });

  const chartData = useMemo(
    () =>
      data.map((row) => ({
        date: row.date,
        regular: row.regular,
        reefer: row.reefer,
      })),
    [data]
  );

  return (
    <LineChart
      className='col-span-full'
      title={t('simulation.charts.occupancy.title')}
      data={chartData}
      indexKey='date'
      tabs={[
        { key: 'regular', label: t('general.regular') },
        { key: 'reefer', label: t('general.reefer') },
      ]}
      showTabTotals={false}
      lines={lines}
      regions={regions}
      showLegend={false}
      yAxisDomain={['auto', 'auto']}
    />
  );
};
